import ac from 'argument-contracts';
import { AppletHost, MOMENT_FORMAT_STRING } from '@meltwater/applet-host';
import { AppletHostSerialization } from '../applet-host-serialization';

/**
 * Produces an {@link AppletHostSerialization} from an AppletHost namespace
 *
 * @param {object} options - See below
 * @param {AppletHost} options.appletHost - The AppletHost from which namespace data should be serialized
 * @param {string} [options.namespace] - The name of which namespace to serialize. Will use the default namespace if none is specified.
 * @returns {AppletHostSerialization} - The serialized applet host settings
 */
export async function fromAppletHost ({ appletHost, namespace }) {
    ac.assertType(appletHost, AppletHost, 'AppletHost');

    if (namespace !== undefined) {
        ac.assertString(namespace, 'namespace');
    }

    const coordinatedQueryTime = await appletHost.getCoordinatedQueryTime({ namespace });
    const dateRange = await appletHost.getDateRange({ namespace });
    const inputs = await appletHost.getInputs({ namespace });

    const filters = appletHost.getFilters
        ? await appletHost.getFilters({ namespace })
        : [];

    return new AppletHostSerialization({
        coordinatedQueryTime: coordinatedQueryTime.toString(),
        inputs: inputs.map(input => input.toString()),
        duration: dateRange.duration,
        durationUnits: dateRange.durationUnits,
        endDate: dateRange.getEndDate().format(MOMENT_FORMAT_STRING),
        filters,
        rangeType: dateRange.rangeType,
        startDate: dateRange.startDate.format(MOMENT_FORMAT_STRING),
        timezone:  dateRange.timezone
    });
}
